import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Music, Mic2, Camera, Disc3 } from "lucide-react";

const socialProofMessages = [
  { icon: Mic2, text: "James just booked a Recording Session", time: "2 minutes ago", color: "text-purple-400" },
  { icon: Star, text: "Sarah left a 5-star review", time: "5 minutes ago", color: "text-yellow-400" },
  { icon: Disc3, text: "DJ Room booked for Saturday", time: "8 minutes ago", color: "text-blue-400" },
  { icon: Music, text: "Marcus completed his album mixing", time: "12 minutes ago", color: "text-green-400" },
  { icon: Camera, text: "Emily booked a Press Shot session", time: "15 minutes ago", color: "text-pink-400" },
  { icon: Mic2, text: "New artist signed up for lessons", time: "18 minutes ago", color: "text-cyan-400" },
  { icon: Star, text: "Another 5-star review received!", time: "22 minutes ago", color: "text-yellow-400" },
  { icon: Disc3, text: "Production Suite booked for mixing", time: "25 minutes ago", color: "text-orange-400" },
];

export default function SocialProofNotifications() {
  const [currentNotification, setCurrentNotification] = useState(null);
  const [notificationIndex, setNotificationIndex] = useState(0);

  useEffect(() => {
    // Don't show on first visit to avoid overwhelming users
    const visitCount = parseInt(localStorage.getItem("visit_count") || "0");
    localStorage.setItem("visit_count", (visitCount + 1).toString());
    
    if (visitCount < 1) return; // Skip on first visit

    // Show first notification after 15 seconds
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 15000);

    return () => clearTimeout(initialDelay);
  }, []);

  const showNotification = () => {
    const randomIndex = Math.floor(Math.random() * socialProofMessages.length);
    setCurrentNotification(socialProofMessages[randomIndex]);
    setNotificationIndex(prev => prev + 1);

    // Hide after 5 seconds
    setTimeout(() => {
      setCurrentNotification(null);
      
      // Show next notification after 30-60 seconds
      const nextDelay = 30000 + Math.random() * 30000;
      setTimeout(showNotification, nextDelay);
    }, 5000);
  };

  if (!currentNotification) return null;

  const IconComponent = currentNotification.icon;

  return (
    <AnimatePresence>
      <motion.div
        key={notificationIndex}
        initial={{ opacity: 0, x: -100, y: 0 }}
        animate={{ opacity: 1, x: 0, y: 0 }}
        exit={{ opacity: 0, x: -100 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        className="fixed bottom-24 left-4 z-50 max-w-sm"
      >
        <div className="bg-dream-surface/95 backdrop-blur-md border border-dream-border rounded-xl p-4 shadow-xl flex items-center gap-3">
          <div className={`w-10 h-10 rounded-full bg-dream-bg flex items-center justify-center ${currentNotification.color}`}>
            <IconComponent className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <p className="text-white text-sm font-medium">{currentNotification.text}</p>
            <p className="text-white/40 text-xs">{currentNotification.time}</p>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
